var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 8.894 4.896 8 6 8H32C33.104 8 34 8.894 34 10C34 11.106 33.104 12 32 12H6C4.896 12 4 11.106 4 10ZM42 22H6C4.896 22 4 22.894 4 24C4 25.106 4.896 26 6 26H42C43.104 26 44 25.106 44 24C44 22.894 43.104 22 42 22ZM24 36H6C4.896 36 4 36.894 4 38C4 39.106 4.896 40 6 40H24C25.104 40 26 39.106 26 38C26 36.894 25.104 36 24 36Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6de228f4.svg";
export { ForwardRef as ReactComponent };